/* global-coupons.js
   Reads the JSON coupon list emitted by
   sections/global-coupon-manager.liquid (#GlobalCouponData)
   and renders the filtered list into the Product Page and
   Cart Drawer placeholder containers.
   Eligibility + minimum-purchase gates are evaluated client-side
   against the data attributes emitted by each consumer section:
     PDP container    data-pdp-handle, data-pdp-price, data-pdp-collections (csv)
     Cart container   data-gc-cart-total, data-gc-cart-items (JSON array) */
(function () {
  "use strict";

  if (window.__globalCouponsInit) return;
  window.__globalCouponsInit = true;

  var DISCOUNT_KEY = "active_shopify_discount";

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function csv(v) {
    return String(v == null ? "" : v)
      .split(",")
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);
  }

  function escapeHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (m) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      }[m];
    });
  }

  function formatRupees(n) {
    var v = Math.round(Number(n) || 0);
    return "Rs. " + v.toLocaleString("en-IN");
  }

  function parseRupees(val) {
    var n = parseFloat(val) || 0;
    if (n >= 100000) {
      return Math.round(n / 100);
    }
    return Math.round(n);
  }

  function parseCurrencyString(str) {
    if (!str) return 0;
    var clean = String(str)
      .replace(/Rs\.?|₹/gi, "")
      .replace(/,/g, "")
      .trim();
    var match = clean.match(/[\d]+(?:\.\d+)?/);
    return match ? parseFloat(match[0]) : 0;
  }

  function getCartSubtotalInRupees() {
    if (window.cart) {
      if (typeof window.cart.original_total_price === "number") {
        return Math.round(window.cart.original_total_price / 100);
      }
      if (typeof window.cart.total_price === "number") {
        return Math.round(window.cart.total_price / 100);
      }
    }
    var subtotalEl = document.querySelector("[data-cart-subtotal]");
    if (subtotalEl && subtotalEl.textContent) {
      var parsed = parseCurrencyString(subtotalEl.textContent);
      if (!isNaN(parsed) && parsed > 0) {
        return Math.round(parsed);
      }
    }
    var target = document.querySelector('[data-global-coupons-target="cart"]');
    if (target) {
      if (target.hasAttribute("data-gc-cart-total-rupees")) {
        return Math.round(
          parseFloat(target.getAttribute("data-gc-cart-total-rupees")) || 0,
        );
      }
      var raw = parseFloat(target.getAttribute("data-gc-cart-total")) || 0;
      return Math.round(raw / 100);
    }
    return 0;
  }

  function getProductPriceInRupees(root) {
    if (root.hasAttribute("data-pdp-price-rupees")) {
      return Math.round(
        parseFloat(root.getAttribute("data-pdp-price-rupees")) || 0,
      );
    }
    var raw = parseFloat(root.getAttribute("data-pdp-price")) || 0;
    return Math.round(raw / 100);
  }

  /* -------------------- Eligibility + min-purchase -------------------- */

  function eligibleFor(c, ctx) {
    var elig = c.eligibility || "all";
    if (elig === "all") return true;

    if (elig === "collection") {
      var tcol =
        (typeof c.target_collection === "object" && c.target_collection
          ? c.target_collection.handle
          : c.target_collection) || "";
      if (!tcol) return true;
      if (ctx.kind === "product") return ctx.collections.indexOf(tcol) !== -1;
      for (var i = 0; i < ctx.items.length; i++) {
        var line = ctx.items[i];
        if (csv(line.collections).indexOf(tcol) !== -1) return true;
        // Same fallback calculateEligibleSubtotal() uses, so the coupon cannot
        // be listed here and then valued against a different item set.
        if (
          line.url &&
          String(line.url).toLowerCase().indexOf("/collections/" + tcol) !== -1
        ) {
          return true;
        }
      }
      return false;
    }

    if (elig === "product") {
      var tprod =
        (typeof c.target_product === "object" && c.target_product
          ? c.target_product.handle
          : c.target_product) || "";
      if (!tprod) return true;
      if (ctx.kind === "product") return ctx.handle === tprod;
      for (var j = 0; j < ctx.items.length; j++) {
        if (ctx.items[j].handle === tprod) return true;
      }
      return false;
    }
    return false;
  }

  function minOk(c, ctx) {
    if (ctx && ctx.kind === "product") return true;
    var min = parseRupees(c.min_purchase);
    if (min <= 0) return true;
    var current = Math.round(Number(ctx.price) || 0);
    return current >= min;
  }

  function passes(c, ctx) {
    return (
      !!c.active &&
      !!c.code &&
      !!c.title &&
      eligibleFor(c, ctx) &&
      minOk(c, ctx)
    );
  }

  /* -------------------- PDP renderer (simplified) -------------------- */

  function renderPdp(root, coupons) {
    var ctx = {
      kind: "product",
      handle: root.getAttribute("data-pdp-handle") || "",
      price: getProductPriceInRupees(root),
      collections: csv(root.getAttribute("data-pdp-collections")),
    };

    var visible = [];
    for (var i = 0; i < coupons.length; i++) {
      if (passes(coupons[i], ctx)) visible.push(coupons[i]);
    }

    if (visible.length === 0) {
      root.innerHTML = "";
      return;
    }

    function renderRow(c, hasDashedBorder) {
      return (
        "" +
        '<div class="pdp-promo-banner__row" style="display:flex;align-items:center;gap:10px;padding:8px 0;' +
        (hasDashedBorder
          ? "border-top:1px dashed var(--color-gold-pale);"
          : "") +
        '">' +
        '<span class="pdp-promo-banner__icon" aria-hidden="true" ' +
        'style="display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;width:28px;height:28px;background:#faf0e0;border:1px solid #c5a45a;border-radius:6px;color:#5c0a1e;font-size:14px;">&#127873;</span>' +
        '<span class="pdp-promo-banner__text" ' +
        'style="font-family:var(--font-body);font-size:13px;font-weight:600;color:#2c1c1f;line-height:1.4;letter-spacing:0.01em;">' +
        escapeHtml(c.title) +
        "</span>" +
        "</div>"
      );
    }

    var bannerStyle =
      "margin:2px 0;padding:4px 16px;" +
      "background:linear-gradient(180deg,#fdf6ec 0%,#faf0e0 100%);" +
      "border:1px solid var(--color-gold-pale);border-radius:10px;" +
      "box-shadow:0 1px 0 rgba(90,26,43,0.04);";

    if (visible.length === 1) {
      root.innerHTML =
        "" +
        '<div class="pdp-promo-banner" style="' +
        bannerStyle +
        '">' +
        renderRow(visible[0], false) +
        "</div>";
      return;
    }

    var subsequentRows = "";
    for (var k = 1; k < visible.length; k++) {
      subsequentRows += renderRow(visible[k], true);
    }

    root.innerHTML =
      "" +
      "<style>" +
      ".pdp-promo-accordion summary::-webkit-details-marker { display: none; }" +
      ".pdp-promo-accordion summary { list-style: none; }" +
      ".pdp-promo-accordion summary::marker { display: none; }" +
      ".pdp-promo-accordion[open] .pdp-promo-chevron { transform: rotate(180deg); }" +
      "</style>" +
      '<details class="pdp-promo-accordion" style="' +
      bannerStyle +
      '">' +
      '<summary style="display:flex;align-items:center;justify-content:space-between;cursor:pointer;list-style:none;outline:none;">' +
      '<div style="display:flex;align-items:center;gap:10px;padding:8px 0;flex:1 1 auto;min-width:0;">' +
      '<span class="pdp-promo-banner__icon" aria-hidden="true" ' +
      'style="display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;width:28px;height:28px;background:#faf0e0;border:1px solid #c5a45a;border-radius:6px;color:#5c0a1e;font-size:14px;">&#127873;</span>' +
      '<span class="pdp-promo-banner__text" ' +
      'style="font-family:var(--font-body);font-size:13px;font-weight:600;color:#2c1c1f;line-height:1.4;letter-spacing:0.01em;">' +
      escapeHtml(visible[0].title) +
      "</span>" +
      "</div>" +
      '<svg class="pdp-promo-chevron" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="#5c0a1e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-left:12px;transition:transform 0.2s ease;">' +
      '<polyline points="6 9 12 15 18 9"/>' +
      "</svg>" +
      "</summary>" +
      '<div class="pdp-promo-accordion__body">' +
      subsequentRows +
      "</div>" +
      "</details>";
  }

  /* -------------------- State & Checkout Synchronization -------------------- */
  var isCouponApplied = false;
  var appliedCouponCode = "";
  var appliedCouponObj = null;
  var _cachedCoupons = [];
  var _cachedCartItems = [];
  var _statusEl = null;

  function getShopifyRoot() {
    var el = document.getElementById("GlobalCouponData");
    var root = el && el.getAttribute("data-root");
    if (!root) return "/";
    return root.charAt(root.length - 1) === "/" ? root : root + "/";
  }

  /* The status line lives outside the accordion subtree because renderCart
     replaces that subtree with outerHTML. Keeping one stable node means a
     single scoped live region owns every announcement. */
  function ensureStatusEl(root) {
    var host = (root && root.parentNode) || null;
    if (!host) {
      host = document.querySelector('[data-global-coupons-target="cart"]');
      host = host && host.parentNode;
    }
    if (!host) return null;
    if (_statusEl && _statusEl.parentNode === host) return _statusEl;

    _statusEl = document.createElement("p");
    _statusEl.className = "cart-coupon__status";
    _statusEl.setAttribute("data-cart-coupon-status", "");
    _statusEl.setAttribute("role", "status");
    _statusEl.hidden = true;
    host.insertBefore(_statusEl, root ? root.nextSibling : null);
    return _statusEl;
  }

  function setCouponStatus(message, isError) {
    var el = _statusEl;
    if (!el || !el.isConnected) {
      el = ensureStatusEl(
        document.querySelector('[data-global-coupons-target="cart"]'),
      );
    }
    if (!el) {
      if (message) {
        console.warn("[global-coupons]", message);
      }
      return;
    }
    var text = message || "";
    if (text && el.textContent !== text) el.textContent = text;
    el.hidden = !text;
    if (isError) {
      el.setAttribute("data-error", "true");
    } else {
      el.removeAttribute("data-error");
    }
  }

  /* Shopify owns the discount. Both storefront routes below attach a real
     discount to the cart session, which is what makes the code survive
     navigation to checkout and makes /cart.js report a real total_discount.
     Rewriting URLs alone never reached the cart. */
  function describeDiscountError(data, text, status, url) {
    if (data) {
      if (typeof data.message === "string" && data.message) return data.message;
      if (typeof data.error === "string" && data.error) return data.error;
      if (data.errors) {
        try {
          return JSON.stringify(data.errors);
        } catch (e) {}
      }
    }
    var snippet = String(text || "")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, 200);

    /* Be precise about the class of failure. A 401/403 is the store refusing
       the request and a 404 means the route is not served here; neither is
       caused by the coupon's dates or limits, so do not send the merchant
       looking in Shopify > Discounts for something that is not there. */
    var reason;
    if (status === 401 || status === 403) {
      reason = "the store refused the request";
    } else if (status === 404) {
      reason = "this endpoint is not served on this store";
    } else {
      reason = "the request failed";
    }
    return (
      "Could not clear the cart discount - " +
      reason +
      " (HTTP " +
      status +
      " on " +
      url +
      ")" +
      (snippet ? ": " + snippet : ". Check this request in the browser Network tab.")
    );
  }

  function shopifyDiscountRequest(url, contentType, body) {
    return fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": contentType,
        Accept: "application/json",
      },
      body: body,
    }).then(function (res) {
      return res.text().then(function (text) {
        var data = null;
        try {
          data = text ? JSON.parse(text) : null;
        } catch (e) {
          data = null;
        }
        if (!res.ok) {
          var err = new Error(
            describeDiscountError(data, text, res.status, url),
          );
          err.status = res.status;
          err.url = url;
          err.raw = text;
          throw err;
        }
        return data || {};
      });
    });
  }

  function removeShopifyDiscount() {
    return Promise.resolve();
  }

  /* snippets/cart-drawer.liquid listens for this and re-fetches /cart.js so
     the authoritative discount reaches the summary. */
  function requestCartRefresh() {
    try {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } catch (e) {}
  }

  // Restore applied coupon from sessionStorage if present
  try {
    var storedCoupon = sessionStorage.getItem("applied_gc_coupon");
    if (storedCoupon && storedCoupon.trim()) {
      isCouponApplied = true;
      appliedCouponCode = storedCoupon.trim();
    }
  } catch (e) {}

  function getAppliedCouponCode() {
    return isCouponApplied ? (appliedCouponCode || "").trim() : "";
  }

  function setAppliedCouponCode(code) {
    var clean = (code || "").trim();
    if (clean) {
      isCouponApplied = true;
      appliedCouponCode = clean;
      try {
        sessionStorage.setItem("applied_gc_coupon", clean);
      } catch (e) {}
    } else {
      isCouponApplied = false;
      appliedCouponCode = "";
      appliedCouponObj = null;
      try {
        sessionStorage.removeItem("applied_gc_coupon");
        sessionStorage.removeItem("active_shopify_discount");
      } catch (e) {}
    }
  }

  /* The code is now attached to the Shopify cart session, so checkout links
     only carry a defensive ?discount= fallback. Cart forms are deliberately
     left untouched: Shopify's POST /cart ignores a `discount` parameter, so
     rewriting the action or injecting a hidden discount input never applied
     anything on the cart page. */
  function syncCheckoutWithDiscount(code) {
    var cleanCode = isCouponApplied ? (code || "").trim() : "";

    $$('a[href*="/checkout"], [data-cart-checkout]').forEach(function (link) {
      try {
        var url = new URL(link.href, window.location.origin);
        if (cleanCode) {
          url.searchParams.set("discount", cleanCode);
        } else {
          url.searchParams.delete("discount");
        }
        link.href = url.pathname + url.search + url.hash;
      } catch (e) {
        link.href = cleanCode
          ? "/checkout?discount=" + encodeURIComponent(cleanCode)
          : "/checkout";
      }
    });
  }

  function resolveCouponObj(code, btn) {
    for (var i = 0; i < _cachedCoupons.length; i++) {
      if (
        _cachedCoupons[i].code &&
        _cachedCoupons[i].code.toUpperCase() === code.toUpperCase()
      ) {
        return _cachedCoupons[i];
      }
    }
    return {
      code: code,
      type: btn.getAttribute("data-type") || "flat",
      value: parseFloat(btn.getAttribute("data-value")) || 0,
      max: parseFloat(btn.getAttribute("data-max")) || 0,
      min_purchase: parseRupees(btn.getAttribute("data-min-purchase")),
      eligibility: btn.getAttribute("data-eligibility") || "all",
      target_collection: btn.getAttribute("data-target-collection") || "",
      target_product: btn.getAttribute("data-target-product") || "",
    };
  }

  function rerenderCartUi() {
    var cartRoot = document.querySelector(
      '[data-global-coupons-target="cart"]',
    );
    if (cartRoot) renderCart(cartRoot, _cachedCoupons);
  }

  function getItemLinePriceInRupees(item) {
    if (!item) return 0;
    var raw = 0;
    if (typeof item.original_line_price === "number") {
      raw = item.original_line_price;
    } else if (typeof item.final_line_price === "number") {
      raw = item.final_line_price;
    } else if (typeof item.line_price === "number") {
      raw = item.line_price;
    } else if (typeof item.price === "number") {
      if (
        typeof item.quantity === "number" &&
        item.quantity > 1 &&
        item.final_line_price == null &&
        item.line_price == null &&
        item.original_line_price == null
      ) {
        raw = item.price * item.quantity;
      } else {
        raw = item.price;
      }
    } else if (typeof item.price === "string") {
      raw = parseFloat(item.price) || 0;
    }
    return Math.round(raw / 100);
  }

  function getCartItems() {
    if (
      window.cart &&
      Array.isArray(window.cart.items) &&
      window.cart.items.length > 0
    ) {
      return normalizeCartItems(window.cart.items);
    }
    if (_cachedCartItems && _cachedCartItems.length > 0) {
      return _cachedCartItems;
    }
    var target = document.querySelector('[data-global-coupons-target="cart"]');
    if (target) {
      try {
        var dataEl = document.getElementById("GlobalCartItemsData");
        var raw = (dataEl && dataEl.textContent) || "[]";
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length > 0) {
          return parsed;
        }
      } catch (e) {
        console.warn("[global-coupons] data-gc-cart-items parse error", e);
      }
    }
    return [];
  }

  function calculateEligibleSubtotal(coupon, cartTotalRupees, items) {
    var cartTotal = Math.round(Number(cartTotalRupees) || 0);
    if (!coupon || cartTotal <= 0) return 0;

    var elig = (coupon.eligibility || "all").toLowerCase();

    // a) If coupon.eligibility === 'all', then eligible_subtotal = cart_total
    if (elig === "all") {
      return cartTotal;
    }

    var cartItems =
      Array.isArray(items) && items.length > 0 ? items : getCartItems();
    if (!cartItems || cartItems.length === 0) {
      return cartTotal;
    }

    var eligibleSubtotal = 0;

    // b) If coupon.eligibility === 'product', loop the cart items and sum line_price ONLY where item.handle === coupon.target_product
    if (elig === "product") {
      var targetProd = (
        typeof coupon.target_product === "object" && coupon.target_product
          ? coupon.target_product.handle
          : coupon.target_product || ""
      )
        .trim()
        .toLowerCase();

      if (!targetProd) return cartTotal;

      for (var i = 0; i < cartItems.length; i++) {
        var it = cartItems[i];
        var itHandle = (it.handle || it.product_handle || "")
          .trim()
          .toLowerCase();
        if (itHandle === targetProd) {
          eligibleSubtotal += getItemLinePriceInRupees(it);
        }
      }
      return Math.min(eligibleSubtotal, cartTotal);
    }

    // c) If coupon.eligibility === 'collection', loop the cart items and sum line_price ONLY where the item belongs to coupon.target_collection
    if (elig === "collection") {
      var targetCol = (
        typeof coupon.target_collection === "object" && coupon.target_collection
          ? coupon.target_collection.handle
          : coupon.target_collection || ""
      )
        .trim()
        .toLowerCase();

      if (!targetCol) return cartTotal;

      for (var j = 0; j < cartItems.length; j++) {
        var item = cartItems[j];
        var isMatch = false;

        // Check 1: item.collections property (from data-gc-cart-items or item.collections)
        if (item.collections) {
          var colList = csv(item.collections).map(function (c) {
            return c.toLowerCase();
          });
          if (colList.indexOf(targetCol) !== -1) {
            isMatch = true;
          }
        }

        // Check 2: item.url contains '/collections/' + targetCol
        if (!isMatch && item.url) {
          if (
            item.url.toLowerCase().indexOf("/collections/" + targetCol) !== -1
          ) {
            isMatch = true;
          }
        }

        if (isMatch) {
          eligibleSubtotal += getItemLinePriceInRupees(item);
        }
      }
      return Math.min(eligibleSubtotal, cartTotal);
    }

    return cartTotal;
  }

  /* Coupons are configured in the theme editor and applied locally: the theme
     takes the money off in the cart UI and hands the code to checkout through
     ?discount=. Nothing is written to the Shopify cart on Apply, so a discount
     already sitting on the cart when this script boots was left behind by an
     earlier session or a /discount or ?discount= visit.

     The button state comes from theme memory, but the summary row is fed by
     cart.total_discount, so a carried-over discount used to render as "Applied"
     math next to an "Apply" button and survived Remove. Clear it once on boot
     so the customer always starts clean and opts in by pressing Apply. */
  var _reconcileAttempts = 0;

  function reconcileServerDiscount() {
    return;
  }

  function updateCartSummaryWithCoupon(
    appliedCoupon,
    subtotalRupees,
    cartItems,
    force,
  ) {

    var subtotalEl = document.querySelector("[data-cart-subtotal]");
    var discountRow = document.querySelector("[data-cart-discount-row]");
    var discountEl = document.querySelector("[data-cart-discount]");
    var totalEl = document.querySelector("[data-cart-total]");

    var subRupees =
      typeof subtotalRupees === "number"
        ? subtotalRupees
        : getCartSubtotalInRupees();

    var discountRupees = 0;
    if (appliedCoupon && subRupees > 0) {
      var eligibleSubtotal = calculateEligibleSubtotal(
        appliedCoupon,
        subRupees,
        cartItems,
      );

      if (eligibleSubtotal > 0) {
        var type = (appliedCoupon.type || "flat").toLowerCase();
        var val = parseFloat(appliedCoupon.value) || 0;
        var cap = parseFloat(appliedCoupon.max) || 0;

        if (type === "percentage") {
          discountRupees = Math.round(eligibleSubtotal * (val / 100));
          if (cap > 0 && discountRupees > cap) {
            discountRupees = Math.round(cap);
          }
        } else {
          discountRupees = Math.round(val);
        }
        // Guardrail: The final discount value can NEVER exceed the eligible_subtotal
        discountRupees = Math.min(discountRupees, eligibleSubtotal);
      }
    }

    if (discountRow && discountEl) {
      if (discountRupees > 0) {
        discountEl.textContent = "\u2212 " + formatRupees(discountRupees);
        discountRow.hidden = false;
        discountRow.removeAttribute("hidden");
      } else {
        discountEl.textContent = "\u2212 " + formatRupees(0);
        discountRow.hidden = true;
        discountRow.setAttribute("hidden", "");
      }
    }

    if (totalEl) {
      var finalRupees = Math.max(0, subRupees - discountRupees);
      totalEl.textContent = formatRupees(finalRupees);
    }
  }

  /* -------------------- Cart item normalization -------------------- */

  /* #GlobalCartItemsData (sections/cart-drawer.liquid) is the only payload
     that carries each item's `collections` and `handle`. A /cart.js line item
     exposes `product_handle` and no collections at all, so handing those
     straight to eligibleFor() made every collection/product scoped coupon
     fail the moment the drawer rendered live cart data — which emptied the
     accordion. Index the server payload by handle and merge live /cart.js
     items into that shape. */
  var _serverItemsByHandle = {};
  var _itemRefreshInFlight = null;

  function indexServerCartItems() {
    var dataEl = document.getElementById("GlobalCartItemsData");
    var index = {};
    if (dataEl) {
      var parsed = [];
      try {
        var raw = (dataEl.textContent || "").trim();
        parsed = raw ? JSON.parse(raw) : [];
      } catch (e) {
        console.warn("[global-coupons] GlobalCartItemsData parse error", e);
        parsed = [];
      }
      if (Array.isArray(parsed)) {
        for (var i = 0; i < parsed.length; i++) {
          var entry = parsed[i];
          if (entry && entry.handle) index[entry.handle] = entry;
        }
      }
    }
    _serverItemsByHandle = index;
    return index;
  }

  function collectionsFromUrl(url) {
    if (!url) return "";
    var match = String(url).match(/\/collections\/([^/?#]+)/);
    // "/collections/all/..." is the cart's catch-all bucket, never a real
    // collection handle, so it must not satisfy a collection eligibility test.
    if (!match || !match[1] || match[1].toLowerCase() === "all") return "";
    return match[1];
  }

  function normalizeCartItems(items) {
    var out = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it) continue;

      var handle = it.handle || it.product_handle || "";
      var collections = csv(it.collections);
      if (!collections.length && handle && _serverItemsByHandle[handle]) {
        collections = csv(_serverItemsByHandle[handle].collections);
      }
      if (!collections.length) {
        var fromUrl = collectionsFromUrl(it.url);
        if (fromUrl) collections = [fromUrl];
      }

      var normalized = {
        handle: handle,
        collections: collections.join(","),
        url: it.url || "",
        quantity: typeof it.quantity === "number" ? it.quantity : 1,
      };
      ["price", "final_line_price", "original_line_price", "line_price"].forEach(
        function (key) {
          if (typeof it[key] === "number") normalized[key] = it[key];
          else if (key === "price" && typeof it[key] === "string") {
            normalized[key] = parseFloat(it[key]) || 0;
          }
        },
      );
      out.push(normalized);
    }
    return out;
  }

  /* A product added after the last page render has no entry in the server
     index. Re-request the tiny cart-drawer section to pick up its
     collections instead of leaving the accordion empty. The cooldown caps
     this to one request per cart change instead of one per render pass. */
  function refreshServerCartItems() {
    if (_itemRefreshInFlight) return _itemRefreshInFlight;
    if (window.__gcItemRefreshCooldown) return Promise.resolve();
    window.__gcItemRefreshCooldown = true;

    _itemRefreshInFlight = fetch(
      getShopifyRoot() + "cart?sections=cart-drawer",
      {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      },
    )
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .catch(function () {
        return null;
      })
      .then(function (data) {
        _itemRefreshInFlight = null;
        var html = data && data["cart-drawer"];
        if (!html) return;

        var match = html.match(
          /<script id="GlobalCartItemsData"[^>]*>([\s\S]*?)<\/script>/,
        );
        if (!match) return;

        var live = document.getElementById("GlobalCartItemsData");
        if (live) live.textContent = match[1];
        indexServerCartItems();
        // Reopen the one-shot if the cart still references a product the
        // refreshed payload does not describe, so a later cart change can
        // retry instead of leaving the accordion permanently empty.
        if (
          window.cart &&
          Array.isArray(window.cart.items) &&
          hasUnknownHandle(window.cart.items)
        ) {
          return;
        }
        window.__gcItemRefreshCooldown = false;
        rerenderCartUi();
      });

    return _itemRefreshInFlight;
  }

  function hasUnknownHandle(items) {
    for (var i = 0; i < items.length; i++) {
      var handle = items[i] && (items[i].product_handle || items[i].handle);
      if (handle && !_serverItemsByHandle[handle]) return true;
    }
    return false;
  }

  /* -------------------- Cart renderer (pure rupees) -------------------- */

  function renderCart(root, coupons) {
    _cachedCoupons = coupons || [];
    ensureStatusEl(root);
    indexServerCartItems();
    reconcileServerDiscount();

    var items = [];
    try {
      var dataEl = document.getElementById("GlobalCartItemsData");
      var raw = (dataEl && dataEl.textContent) || "[]";
      items = JSON.parse(raw);
    } catch (e) {
      console.warn("[global-coupons] data-gc-cart-items parse error", e);
      items = [];
    }

    if (
      window.cart &&
      Array.isArray(window.cart.items) &&
      window.cart.items.length > 0
    ) {
      items = normalizeCartItems(window.cart.items);
      if (hasUnknownHandle(window.cart.items)) {
        window.__gcItemRefreshCooldown = false;
        refreshServerCartItems();
      }
    }
    _cachedCartItems = items;

    var cartTotalRupees = getCartSubtotalInRupees();

    var ctx = {
      kind: "cart",
      price: cartTotalRupees,
      items: items,
    };

    var visible = [];
    for (var i = 0; i < coupons.length; i++) {
      var c = coupons[i];
      if (c.active && c.code && c.title && eligibleFor(c, ctx)) {
        visible.push(c);
      }
    }

    var appliedCode = isCouponApplied ? getAppliedCouponCode() : "";
    var currentAppliedCoupon = null;

    if (isCouponApplied && appliedCode) {
      for (var j = 0; j < visible.length; j++) {
        if (
          visible[j].code &&
          visible[j].code.toUpperCase() === appliedCode.toUpperCase()
        ) {
          currentAppliedCoupon = visible[j];
          break;
        }
      }
      if (!currentAppliedCoupon && Array.isArray(_cachedCoupons)) {
        for (var cIdx = 0; cIdx < _cachedCoupons.length; cIdx++) {
          if (
            _cachedCoupons[cIdx].code &&
            _cachedCoupons[cIdx].code.toUpperCase() === appliedCode.toUpperCase()
          ) {
            currentAppliedCoupon = _cachedCoupons[cIdx];
            break;
          }
        }
      }
      if (currentAppliedCoupon) {
        var checkMin = parseRupees(currentAppliedCoupon.min_purchase);
        if (checkMin > 0 && cartTotalRupees < checkMin) {
          // Cart subtotal dropped below threshold; revoke applied coupon
          setAppliedCouponCode("");
          appliedCode = "";
          currentAppliedCoupon = null;
        }
      }
      appliedCouponObj = currentAppliedCoupon;
    } else {
      appliedCouponObj = null;
      appliedCode = "";
    }

    updateCartSummaryWithCoupon(appliedCouponObj, cartTotalRupees, items);
    syncCheckoutWithDiscount(appliedCode);

    if (visible.length === 0) {
      if (root.tagName === "DETAILS") {
        var placeholder = document.createElement("div");
        placeholder.setAttribute("data-global-coupons-target", "cart");
        placeholder.setAttribute(
          "data-gc-cart-total-rupees",
          String(cartTotalRupees),
        );
        placeholder.setAttribute("data-gc-cart-items", JSON.stringify(items));
        if (root.parentNode) root.parentNode.replaceChild(placeholder, root);
      } else {
        root.innerHTML = "";
      }
      return;
    }

    var rows = "";
    for (var k = 0; k < visible.length; k++) {
      var coupon = visible[k];
      var minPurchaseRupees = parseRupees(coupon.min_purchase);
      var shortfallRupees = minPurchaseRupees - cartTotalRupees;
      var hasShortfall = minPurchaseRupees > 0 && shortfallRupees > 0;

      var isApplied = Boolean(
        appliedCode &&
        coupon.code &&
        coupon.code.toUpperCase() === appliedCode.toUpperCase(),
      );

      var btnText = isApplied ? "Remove" : "Apply";
      var btnClasses =
        "cart-coupon__apply" + (isApplied ? " is-applied is-active" : "");
      var btnAction = isApplied ? "remove" : "apply";
      var btnDisabledAttr =
        !isApplied && hasShortfall ? ' disabled aria-disabled="true"' : "";

      var shortfallHtml =
        !isApplied && hasShortfall
          ? '<div class="cart-coupon__shortfall" style="font-family:var(--font-body);font-size:11px;color:#8c734b;margin-top:4px;font-weight:500;line-height:1.2;">Add Rs. ' +
            shortfallRupees.toLocaleString("en-IN") +
            " more to apply</div>"
          : "";

      rows +=
        "" +
        '<div class="cart-coupon" data-cart-coupon-row data-coupon-context="cart">' +
        '<div class="cart-coupon__icon" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24">' +
        '<polyline points="20 12 20 22 4 22 4 12"/>' +
        '<rect x="2" y="7" width="20" height="5"/>' +
        '<line x1="12" y1="22" x2="12" y2="7"/>' +
        '<path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>' +
        '<path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>' +
        "</svg>" +
        "</div>" +
        '<div class="cart-coupon__body">' +
        '<div class="cart-coupon__title">' +
        escapeHtml(coupon.title) +
        "</div>" +
        '<div class="cart-coupon__code">' +
        '<span class="cart-coupon__code-label">Code</span>' +
        '<span class="cart-coupon__code-value" data-cart-coupon-code>' +
        escapeHtml(coupon.code) +
        "</span>" +
        "</div>" +
        shortfallHtml +
        "</div>" +
        '<button type="button" class="' +
        btnClasses +
        '" data-cart-coupon-apply' +
        ' data-action="' +
        btnAction +
        '"' +
        ' data-code="' +
        escapeHtml(coupon.code) +
        '"' +
        ' data-type="' +
        escapeHtml(coupon.type || "flat") +
        '"' +
        ' data-value="' +
        escapeHtml(String(coupon.value || 0)) +
        '"' +
        ' data-max="' +
        escapeHtml(String(coupon.max || 0)) +
        '"' +
        ' data-min-purchase="' +
        escapeHtml(String(minPurchaseRupees)) +
        '"' +
        ' data-eligibility="' +
        escapeHtml(coupon.eligibility || "all") +
        '"' +
        ' data-target-collection="' +
        escapeHtml(
          String(
            (typeof coupon.target_collection === "object" &&
            coupon.target_collection
              ? coupon.target_collection.handle
              : coupon.target_collection) || "",
          ),
        ) +
        '"' +
        ' data-target-product="' +
        escapeHtml(
          String(
            (typeof coupon.target_product === "object" && coupon.target_product
              ? coupon.target_product.handle
              : coupon.target_product) || "",
          ),
        ) +
        '"' +
        btnDisabledAttr +
        ">" +
        btnText +
        "</button>" +
        "</div>";
    }

    var wasOpen = root.tagName === "DETAILS" ? root.open : false;

    var styleBlock =
      "<style>" +
      ".cart-coupon__apply.is-applied{background:var(--color-burgundy,#5c0a1e)!important;color:var(--color-gold,#c5a45a)!important;border-color:var(--color-burgundy,#5c0a1e)!important;border-style:solid!important;}" +
      ".cart-coupon__apply[disabled]{opacity:0.5;cursor:not-allowed!important;pointer-events:none;}" +
      ".cart-coupon__status{margin:8px 0 0;font-family:var(--font-body);font-size:12px;line-height:1.35;font-weight:500;color:var(--color-foreground,#2b2b2b);}" +
      ".cart-coupon__status[data-error=\"true\"]{color:var(--color-error,#b3261e);}" +
      ".cart-coupon__status[hidden]{display:none;}" +
      "</style>";

    var accordion =
      "" +
      styleBlock +
      '<details class="cart-drawer__coupons" ' +
      (wasOpen ? "open " : "") +
      'data-global-coupons-target="cart" data-gc-cart-total-rupees="' +
      cartTotalRupees +
      '" data-cart-coupons aria-label="Available coupons">' +
      '<summary class="cart-coupons__summary" data-cart-coupon-toggle>' +
      '<span class="cart-coupons__summary-left">' +
      '<span class="cart-coupons__gift" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24">' +
      '<polyline points="20 12 20 22 4 22 4 12"/>' +
      '<rect x="2" y="7" width="20" height="5"/>' +
      '<line x1="12" y1="22" x2="12" y2="7"/>' +
      '<path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>' +
      '<path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>' +
      "</svg>" +
      "</span>" +
      '<span class="cart-coupons__label">' +
      '<span class="cart-coupons__label-count" data-cart-coupon-count>' +
      visible.length +
      "</span>" +
      " Coupons Available" +
      "</span>" +
      "</span>" +
      '<span class="cart-coupons__chevron" aria-hidden="true">' +
      '<span class="cart-coupons__chevron-label">View</span>' +
      '<svg viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9"/></svg>' +
      "</span>" +
      "</summary>" +
      '<div class="cart-coupons__panel">' +
      rows +
      "</div>" +
      "</details>";

    root.outerHTML = accordion;
    wireCartApplyButtons();
  }

  function wireCartApplyButtons() {
    if (window.__cartApplyWired) return;
    window.__cartApplyWired = true;

    document.addEventListener(
      "click",
      function (e) {
        var btn =
          e.target.closest && e.target.closest("[data-cart-coupon-apply]");
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();

        if (
          btn.hasAttribute("disabled") ||
          btn.disabled ||
          btn.getAttribute("aria-disabled") === "true" ||
          btn.getAttribute("data-busy") === "true"
        ) {
          return;
        }

        var action = btn.getAttribute("data-action") || "apply";
        var code = (btn.getAttribute("data-code") || "").trim();

        btn.setAttribute("data-busy", "true");
        var previousLabel = btn.textContent;
        btn.textContent = action === "remove" ? "Removing…" : "Applying…";

        var settle = function () {
          btn.removeAttribute("data-busy");
          if (btn.isConnected) btn.textContent = previousLabel;
          rerenderCartUi();
        };

        if (action === "remove" || btn.classList.contains("is-applied")) {
          setAppliedCouponCode("");
          setCouponStatus("");
          syncCheckoutWithDiscount("");
          _reconcileAttempts = 3;

          if (window.cart) window.cart.total_discount = 0;
          updateCartSummaryWithCoupon(
            null,
            getCartSubtotalInRupees(),
            _cachedCartItems,
            true,
          );
          settle();
          return;
        }

        // Double check min_purchase against live cart total in rupees
        var cartTotalRupees = getCartSubtotalInRupees();
        var minRupees = parseRupees(btn.getAttribute("data-min-purchase"));

        if (minRupees > 0 && cartTotalRupees < minRupees) {
          setCouponStatus(
            "Add Rs. " +
              (minRupees - cartTotalRupees).toLocaleString("en-IN") +
              " more to use this code.",
            true,
          );
          settle();
          return;
        }

        /* Theme-only apply: set the theme state, let the theme's own math take
           the money off, and stamp ?discount= on the checkout link. */
        appliedCouponObj = resolveCouponObj(code, btn);
        setAppliedCouponCode(code);
        setCouponStatus("Code " + code + " applied.");
        syncCheckoutWithDiscount(code);
        updateCartSummaryWithCoupon(
          appliedCouponObj,
          getCartSubtotalInRupees(),
          _cachedCartItems,
          true,
        );
        settle();
      },
      true,
    );

    /* Carry the code into checkout so the customer never types it. Shopify
       reads ?discount= from the checkout URL and applies the code there.
       If the code is also a real Shopify discount it was already attached to
       the cart session when Apply was pressed, so this only has to hand over
       the code — no pre-flight request, no added latency. */
    document.addEventListener(
      "click",
      function (e) {
        var checkoutTarget =
          e.target.closest &&
          e.target.closest(
            '[data-cart-checkout], a[href*="/checkout"], .cart__checkout-button, button[name="checkout"], input[name="checkout"]',
          );
        if (!checkoutTarget) return;
        if (
          checkoutTarget.getAttribute("aria-disabled") === "true" ||
          checkoutTarget.classList.contains("is-disabled") ||
          checkoutTarget.disabled
        ) {
          return;
        }

        var code = getAppliedCouponCode();
        if (!code) return;

        e.preventDefault();
        syncCheckoutWithDiscount(code);
        window.location.assign(
          getShopifyRoot() + "checkout?discount=" + encodeURIComponent(code),
        );
      },
      true,
    );
  }

  /* -------------------- Bootstrap -------------------- */

  function bootstrap() {
    try {
      var pdpRoot = document.querySelector(
        '[data-global-coupons-target="product"]',
      );
      var cartRoot = document.querySelector(
        '[data-global-coupons-target="cart"]',
      );

      var dataEl = document.getElementById("GlobalCouponData");
      if (!dataEl) {
        if (pdpRoot) pdpRoot.innerHTML = "";
        if (cartRoot) cartRoot.innerHTML = "";
        return;
      }

      var text = (dataEl.textContent || "").trim();
      if (!text || text === "[]") {
        if (pdpRoot) pdpRoot.innerHTML = "";
        if (cartRoot) cartRoot.innerHTML = "";
        return;
      }

      var coupons;
      try {
        coupons = JSON.parse(text);
      } catch (e) {
        console.warn(
          "[global-coupons] JSON.parse failed for #GlobalCouponData",
          e,
        );
        if (pdpRoot) pdpRoot.innerHTML = "";
        if (cartRoot) cartRoot.innerHTML = "";
        return;
      }
      if (!Array.isArray(coupons)) {
        if (pdpRoot) pdpRoot.innerHTML = "";
        if (cartRoot) cartRoot.innerHTML = "";
        return;
      }

      _cachedCoupons = coupons;
      if (pdpRoot) renderPdp(pdpRoot, coupons);
      if (cartRoot) renderCart(cartRoot, coupons);

      // Initialize checkout links and apply listeners
      syncCheckoutWithDiscount(getAppliedCouponCode());
      wireCartApplyButtons();
    } catch (err) {
      console.warn("[global-coupons] bootstrap error", err);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootstrap);
  } else {
    bootstrap();
  }
  document.addEventListener("shopify:section:load", bootstrap);
  document.addEventListener("cart:updated", bootstrap);
})();
